var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.52271V5.52271H11V9.52271H15V11.5227H11V15.5227H9V11.5227H5V9.52271H9ZM10 20.5227C4.477 20.5227 0 16.0457 0 10.5227C0 4.99971 4.477 0.522705 10 0.522705C15.523 0.522705 20 4.99971 20 10.5227C20 16.0457 15.523 20.5227 10 20.5227ZM10 18.5227C12.1217 18.5227 14.1566 17.6799 15.6569 16.1796C17.1571 14.6793 18 12.6444 18 10.5227C18 8.40097 17.1571 6.36614 15.6569 4.86585C14.1566 3.36556 12.1217 2.52271 10 2.52271C7.87827 2.52271 5.84344 3.36556 4.34315 4.86585C2.84285 6.36614 2 8.40097 2 10.5227C2 12.6444 2.84285 14.6793 4.34315 16.1796C5.84344 17.6799 7.87827 18.5227 10 18.5227Z",
    fill: "#00758B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.1f3540bfc840b94cc51cccaaecfdc1a3.svg";
export { ForwardRef as ReactComponent };